import { Cell } from '@table-library/react-table-library/table';
import numeral from 'numeral';
import { CellTree } from '@table-library/react-table-library/tree';

export const webNodesTypes = ['news', 'video', 'image', 'web_other'];

export const COLUMNS = (t) => [
    {
        label: t('tools.live_url.google_surfaces.googleSurface'),
        key: 'label',
        data: 'label',
        Component: CellTree,
        style: (item) => {
            if (webNodesTypes.includes(item.searchtype)) {
                return { fontSize: '13px' };
            }
            return {};
        },
    },
    {
        label: t('tools.live_url.google_surfaces.clicksShare'),
        key: 'share',
        data: 'share',
        Component: Cell,
        style: (item) => {
            if (webNodesTypes.includes(item.searchtype)) {
                return { fontSize: '13px' };
            }
            return {};
        },
        renderCell: ({ item, csvDownload, allData }) => {
            const clickSum = getSum(allData);
            const data = item.clicks / clickSum;
            if (csvDownload) return data;

            return numeral(data).format('0.00%');
        },
    },
    {
        label: t('tools.live_url.google_surfaces.clicks'),
        key: 'clicks',
        data: 'clicks',
        Component: Cell,
        style: (item) => {
            if (webNodesTypes.includes(item.searchtype)) {
                return { fontSize: '13px' };
            }
            return {};
        },
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return numeral(data).format('0.0a');
        },
    },
    {
        label: t('tools.live_url.google_surfaces.impressions'),
        key: 'impressions',
        data: 'impressions',
        Component: Cell,
        style: (item) => {
            if (webNodesTypes.includes(item.searchtype)) {
                return { fontSize: '13px' };
            }
            return {};
        },
        renderCell: ({ data, csvDownload }) => {
            if (csvDownload) return data;

            return numeral(data).format('0.0a');
        },
    },
    {
        label: t('tools.live_url.google_surfaces.avgPosition'),
        key: 'position',
        data: 'position',
        Component: Cell,
        style: (item) => {
            if (webNodesTypes.includes(item.searchtype)) {
                return { fontSize: '13px' };
            }
            return {};
        },
        renderCell: ({ data, csvDownload }) => {
            if (!data) return '-';
            if (csvDownload) return data;

            return numeral(data).format('0.0a');
        },
    },
    {
        label: t('tools.live_url.google_surfaces.ctr'),
        key: 'ctr',
        data: 'ctr',
        Component: Cell,
        style: (item) => {
            if (webNodesTypes.includes(item.searchtype)) {
                return { fontSize: '13px' };
            }
            return {};
        },
        renderCell: ({ item, csvDownload }) => {
            const data = item.clicks / item.impressions;
            if (csvDownload) return data;

            return numeral(data).format('0.00%');
        },
    },
];

export function getSum(data) {
    const sum = data.reduce((acc, curr) => {
        if (!webNodesTypes.includes(curr.searchtype)) acc = acc + curr.clicks;
        return acc;
    }, 0);
    return sum;
}

export function getPercent(allData, newData) {
    const sumAllData = allData.reduce((acc, curr) => acc + curr.pages, 0);
    const percent = (100 * newData) / sumAllData;
    return percent;
}

export function getPercentForChart(allData, oneData) {
    const sumAllData = allData.reduce((acc, curr) => acc + curr, 0);
    const percent = (100 * oneData) / sumAllData;
    return percent;
}
